import { request } from '@/utils/request'
export default {
    knowledgeList: (params, loading) => {
        return request('/api/firmsaleintention/page', params, loading)
    },
    insertIntentions: (params, loading) => {
        return request('/api/firmsaleintention/insert', params, loading)
    },
    editIntentions: (params, loading) => {
        return request('/api/firmsaleintention/edit', params, loading)
    },
    editIntShow: (params, loading) => {
        return request('/api/firmsaleintention/show', params, loading)
    },
    isExpress: (params, loading) => {
        return request('/api/firmsaleintentexpress/search', params, loading)
    },
    uptcondition: (params, loading) => {
        return request('/api/firmsaleintention/uptcondition', params, loading)
    },
    showCondition: (params, loading) => {
        return request('/api/firmsaleintention/condition', params, loading)
    },
    deleteIntention: (params, loading) => {
        return request('/api/firmsaleintention/delete', params, loading)
    },
    feedBackList: (params, loading) => {
        return request('/api/firmsaleintentfeedback/query', params, loading)
    },
    feedBackOption: (params, loading) => {
        return request('/api/firmsaleintention/list', params, loading)
    },
    editMark: (params, loading) => {
        return request('/api/firmsaleintentexpress/edit/intent', params, loading)
    },
    addMark: (params, loading) => {
        return request('/api/firmsaleintentfeedback/addintent', params, loading)
    },
    hotList: (params, loading) => {
        return request('/api/hotsearchcontent/page', params, loading)
    },
    updateHotItem: (params, loading) => {
        return request('/api/hotsearchcontent/update', params, loading)
    },
    addItem: (params, loading) => {
        return request('/api/hotsearchcontent/create', params, loading)
    },
    deleteHotItem: (params, loading) => {
        return request('/api/hotsearchcontent/delete', params, loading)
    },
}


// WEBPACK FOOTER //
// ./src/api/kbs.js